module.exports = __webpack_public_path__ + "img/potencia_c.2d280138.svg";